import $ from 'jquery';
import { initAccessibility } from './accessibility';
import './booking'; // Import booking logic
import { initAllBookingForms } from './booking/form-ui';
/**
 * Store to keep track of previous heights before form view
 */
window.bookingHeightStore = window.bookingHeightStore || {};
/**
 * Store current height before switching views
 */
window.storeBookingHeight = function (expertId) {
    const slide = $(`.slide:has(.expert-booking-content[data-expert-id="${expertId}"])`).filter('.booking-active');
    if (slide.length) {
        let activeTabPane = slide.closest('.tab-pane.active');
        if (!activeTabPane.length && window.innerWidth <= 480) {
            activeTabPane = slide.closest('.tab-pane');
        }
        if (!activeTabPane.length)
            return;
        const tabContent = activeTabPane.find('.tab-content').first();
        if (tabContent.length) {
            const currentHeight = tabContent.css('height');
            window.bookingHeightStore[expertId] = currentHeight;
        }
    }
};
/**
 * Restore previously stored height
 */
window.restoreBookingHeight = function (expertId) {
    const slide = $(`.slide:has(.expert-booking-content[data-expert-id="${expertId}"])`).filter('.booking-active');
    if (slide.length) {
        let activeTabPane = slide.closest('.tab-pane.active');
        if (!activeTabPane.length && window.innerWidth <= 480) {
            activeTabPane = slide.closest('.tab-pane');
        }
        if (!activeTabPane.length)
            return;
        const tabContent = activeTabPane.find('.tab-content').first();
        if (tabContent.length && window.bookingHeightStore[expertId]) {
            setTimeout(() => {
                tabContent.css('transition', 'none');
                tabContent.css('height', window.bookingHeightStore[expertId]);
                setTimeout(() => {
                    tabContent.css('transition', '');
                }, 10);
            }, 50);
        }
    }
};
/**
 * ==================================================
 * Sets the wrapper people slider for accessibility
 * ==================================================
 *
 * This file dynamically sets the tabIndex and focus by observing for mutations
 *
 * @Author Amal Ajith PM
 */
$(document).ready(function () {
    initAccessibility();
    function setupTabs($container) {
        const $slides = $container.find('.slide');
        if ($slides.length) {
            if ($slides.length === 1) {
                $container.find('.tab-titles').hide();
            }
            else {
                $container.find('.tab-titles').show();
            }
            $container.find('.top-social').hide();
            $container.find('.bottom-social').show();
            let html = "";
            $slides.each(function (index) {
                const $this = $(this);
                const title = $this.find('.box-title h3').text();
                $this.addClass("tab-pane").attr('id', "silder" + index);
                const activeClass = index === 0 ? "active" : "";
                html += `<li key=${index} data-tab="silder${index}" class="tab-title ${activeClass}"><a class="taba" href="#silder${index}">${title}</a></li>`;
                if (index === 0) {
                    $this.addClass("active");
                }
            });
            $container.find('.tab-titles').html(html);
            const tabs = $container.find('.tab-titles li');
            const tabContents = $container.find('.tab-pane');
            tabs.each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();
                    tabs.removeClass('active');
                    tabContents.removeClass('active');
                    $(this).addClass('active');
                    const contentId = $(this).data('tab');
                    const contentElement = $container.find(`#${contentId}`);
                    if (contentElement.length) {
                        contentElement.addClass('active');
                    }
                });
            });
        }
        else {
            $container.find('.top-social').show();
            $container.find('.bottom-social').hide();
        }
    }
    $('.tabs-boxed').each(function () {
        setupTabs($(this));
    });
});
$(document).ready(function () {
    function updateSliderClass() {
        if (window.innerWidth <= 480) {
            $('.test').removeClass('tabs-boxed');
            $('.test').addClass('slider');
        }
        else {
            $('.test').removeClass('tabs');
            $('.slidertest').addClass('slider-nav');
        }
    }
    function initSlider() {
        if (window.innerWidth <= 480) {
            if (!$('.test .slider-list').hasClass('slick-initialized')) {
                const $slider = $('.wp-block-cg-blocks-wrapper-people-slider-s .test .slider-list');
                $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    const activeElement = document.activeElement;
                    if (activeElement && $(activeElement).closest('.slick-slide').length) {
                        activeElement.blur();
                    }
                });
                $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    const i = (currentSlide || 0) + 1;
                    const progressWidth = (i / slick.slideCount) * 100;
                    $('.progress-bar').css('width', progressWidth + '%');
                    const $activeSlide = $(slick.$slides[currentSlide]);
                    if ($activeSlide.hasClass('booking-active') || $activeSlide.find('.expert-booking-trigger.active').length) {
                        $activeSlide.removeAttr('aria-hidden');
                    }
                });
                $slider.slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    arrows: false
                });
                $slider.find('.proper-form-wrapper, form, button[type="submit"]').on('click touchstart mousedown', function (e) {
                    e.stopPropagation();
                });
                $slider.on('mousedown touchstart', '.expert-booking-trigger', function () {
                    const slide = $(this).closest('.slide');
                    if (slide.length) {
                        slide.removeAttr('aria-hidden');
                    }
                });
            }
        }
        else {
            if ($('.test .slider-list').hasClass('slick-initialized')) {
                $('.test .slider-list').slick('unslick');
            }
        }
    }
    function adjustCardHeights() {
        $('.test .slider-list').each(function () {
            let maxHeight = 0;
            const cardsInRow = $(this).find('.box-inner');
            cardsInRow.css('height', 'auto');
            cardsInRow.each(function () {
                const cardHeight = $(this).outerHeight();
                if (cardHeight > maxHeight) {
                    maxHeight = cardHeight;
                }
            });
            cardsInRow.css('height', maxHeight);
        });
    }
    function extractModals() {
        $('.wp-block-cg-blocks-wrapper-people-slider-s').each(function () {
            const $modals = $(this).find('.modal').detach();
            if ($modals.length) {
                $(this).find('.content-title').closest('.container').append($modals);
            }
        });
    }
    updateSliderClass();
    initSlider();
    adjustCardHeights();
    extractModals();
    $(window).resize(function () {
        updateSliderClass();
        initSlider();
        adjustCardHeights();
    });
});
$(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
        var modal = $('.modal.show');
        if (modal.length) {
            modal.modal('hide');
        }
    }
});
$(document).ready(function () {
    function adjustBoxImgHeight() {
        if ($(window).width() < 720) {
            $('.wp-block-cg-blocks-wrapper-people-slider-s .tab-pane').each(function () {
                var tabPaneWidth = $(this).width();
                var newHeight = (297 / 320) * tabPaneWidth;
                $(this).find('.box-img-wrapper').css('height', newHeight + 'px');
            });
        }
    }
    adjustBoxImgHeight();
    $(window).resize(adjustBoxImgHeight);
});
$(document).on('click', '.expert-booking-trigger', function () {
    const $trigger = $(this);
    const slide = $trigger.closest('.slide');
    const content = $trigger.next('.expert-booking-content');
    const expertId = content.data('expert-id');
    let activeTabPane = slide.closest('.tab-pane.active');
    if (!activeTabPane.length && window.innerWidth <= 480) {
        activeTabPane = slide.closest('.tab-pane');
    }
    if (!activeTabPane.length)
        return;
    const tabContent = activeTabPane.find('.tab-content').first();
    $trigger.toggleClass('active');
    slide.toggleClass('booking-active');
    if ($trigger.hasClass('active')) {
        slide.removeAttr('aria-hidden');
    }
    if (expertId && window.storeBookingHeight) {
        window.storeBookingHeight(expertId);
    }
    content.slideToggle(300, function () {
        if (!tabContent.length)
            return;
        const padding = 32;
        if (slide.hasClass('booking-active')) {
            requestAnimationFrame(() => {
                const targetHeight = tabContent[0].scrollHeight + padding;
                tabContent.css('height', targetHeight + 'px');
            });
        }
        else {
            requestAnimationFrame(() => {
                if (otherOpenAccordions.length > 0) {
                    const newHeight = tabContent[0].scrollHeight + padding;
                    tabContent.css('height', newHeight + 'px');
                }
                else {
                    tabContent.css('height', 'auto');
                }
            });
        }
    });
});
$(document).ready(function () {
    initAllBookingForms();
});
